import React from "react";
import RemoveDialog, {
  DeleteMessage,
} from "../../../utils/dialog/RemoveDialog";

const DeleteAssetDialog = ({ open, onClose, onConfirm, assetName }) => {
  return (
    <RemoveDialog
      open={open}
      onClose={onClose}
      title={"Delete Asset"}
      onConfirm={onConfirm}
    >
      <DeleteMessage
        body1={
          <>
            Are you sure you want to delete <strong>{assetName}</strong>?
          </>
        }
        body2={
          "This will permanently remove the asset and all its associated data, including principal paid records and calculations."
        }
      />
    </RemoveDialog>
  );
};

export default DeleteAssetDialog;
